import { COMPLETED_INDEX, IN_PROGRESS_INDEX, QUOTE_PENDING_INDEX, xtrfStatusOptions } from './xtrfStatusOptions'
import { Status } from '../../../../interfaces/Status'

const statusTransform = (elemStatus: string): Status => {
    let status = {
        name: 'xtrf.page_project_list.status.no_status',
        color: 'primary',
    }
    if (!elemStatus) return status

    if (xtrfStatusOptions[IN_PROGRESS_INDEX].value.includes(elemStatus)) {
        status = {
            name: 'xtrf.page_project_list.status.in_progress',
            color: 'inProgress',
        }
    } else if (xtrfStatusOptions[COMPLETED_INDEX].value.includes(elemStatus)) {
        status = {
            name: 'xtrf.page_project_list.status.completed',
            color: 'completed',
        }
    } else if (xtrfStatusOptions[QUOTE_PENDING_INDEX].value.includes(elemStatus)) {
        status = {
            name: 'xtrf.page_project_list.status.quote_pending',
            color: 'pending',
        }
    }
    return status
}

export default statusTransform
